import React from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { pathFor } from '../../nucleus/map';

// THE OLD DOORS — /plugins/<id>/setup and /plugins/<id>/consent. Apps link
// people here (with ?return_to= and, for a group, ?group_id=), the OAuth
// callback lands here (?connected=1, ?not_connected&reason=…), and the run
// gate's notices name them. Both open the Plugins page of that space with the
// plugin's inspector open, and its setup sheet with it: /setup at the first
// step still missing (&setup=first), /consent at Turn on (&setup=approve).
// What the address carried rides along for the inspector to read.
const CARRIED = ['return_to', 'approved', 'connected', 'not_connected', 'reason', 'tool'];
const STEP = { setup: 'first', consent: 'approve' };

/** Where a door leads: the plugin open in its space; `door` ('setup' | 'consent') opens its setup sheet. */
export function doorTarget(pluginId, params, door = null) {
    const groupId = params.get('group_id') || null;
    const q = new URLSearchParams();
    q.set('open', pluginId);
    CARRIED.forEach((k) => { if (params.has(k)) q.set(k, params.get(k)); });
    if (STEP[door] && !params.has('tool')) q.set('setup', STEP[door]);
    return `${pathFor('plugins', null, groupId)}?${q}`;
}

export default function PluginDoor() {
    const { pluginId } = useParams();
    const [params] = useSearchParams();
    const { pathname } = useLocation();
    const door = pathname.replace(/\/+$/, '').endsWith('/consent') ? 'consent' : 'setup';
    return <Navigate replace to={doorTarget(pluginId, params, door)} />;
}
